module.exports = __webpack_public_path__ + "static/media/points8_1.c8b1db9c.png";